import { Injectable } from '@angular/core';
import { Subject } from 'rxjs'

@Injectable()
export class SbEvent {
    public breadcrumbLoaded = new Subject()
    public historyGoBack = new Subject()
    public resourcesLoaded = new Subject()
    public escapePressed = new Subject()
    public resourceSetChanging = new Subject()
}
